import { observer } from 'mobx-react-lite';
import Chip, { CHIP_COLORS } from '../../../../components/chip/chip';
import useDashboardTranslation from '../../../../dashboard-translation/hooks/dashboard-translation-hook';
import { LocaleStatus } from '../../../../services/api/locales-service';
import LocaleStore from '../../stores/locale-store';
import IconWarning from '../../../../components/icons/icon-warning/icon-warning';
import IconError from '../../../../components/icons/icon-error/icon-error';
import "./locale-status-chip.scss";

const LOCALE_STATUS_MAP: Record<LocaleStatus, {
  translationKey: string;
  color: CHIP_COLORS;
}> = {
  [LocaleStatus.CUSTOMIZED]: {
    translationKey: 'FULL_TRANSLATIONS',
    color: CHIP_COLORS.GREEN,
  },
  [LocaleStatus.SYSTEM_DEFAULT]: {
    translationKey: 'SYSTEM_DEFAULT',
    color: CHIP_COLORS.BLUE,
  },
  [LocaleStatus.NO_TRANSLATIONS]: {
    translationKey: 'NO_TRANSLATIONS',
    color: CHIP_COLORS.RED,
  },
  [LocaleStatus.MISSING_TRANSLATIONS]: {
    translationKey: 'MISSING_TRANSLATIONS',
    color: CHIP_COLORS.ORANGE,
  },
};

interface LocaleStatusChipProps {
  locale: LocaleStore;
}

const SCOPE = 'dashboard-portal-and-emails-language';

const LocaleStatusChip: React.FC<LocaleStatusChipProps> = observer(({ locale }) => {
    const { getTranslation } = useDashboardTranslation();
    const { localeStatus } = locale;

    const { translationKey, color } = LOCALE_STATUS_MAP[localeStatus] || LOCALE_STATUS_MAP[LocaleStatus.SYSTEM_DEFAULT];
    const label = getTranslation(translationKey, SCOPE);

    return (<div className="locale-status-chip-container">
        <Chip label={label} color={color} />
        <div className="no-translation-icon">
            {localeStatus === LocaleStatus.NO_TRANSLATIONS && (
                <IconError />
            )}
            {localeStatus === LocaleStatus.MISSING_TRANSLATIONS && (
                <IconWarning color={"var(--color-accent-4"} />
            )}
        </div>
    </div>);
});

export default LocaleStatusChip;
